// extracted by mini-css-extract-plugin
export default {"container":"PermissionItem__container___h84BI","unitDot":"PermissionItem__unitDot___j4xxF","subUnitDot":"PermissionItem__subUnitDot___caYUV","label":"PermissionItem__label___b1d1x"};